import { render, staticRenderFns } from "./ReplaceOldCourseWizardDlg.vue?vue&type=template&id=b79d3108&scoped=true&"
import script from "./ReplaceOldCourseWizardDlg.vue?vue&type=script&lang=ts&"
export * from "./ReplaceOldCourseWizardDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ReplaceOldCourseWizardDlg.vue?vue&type=style&index=0&id=b79d3108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d3108",
  null
  
)

export default component.exports